import { render, staticRenderFns } from "./SeccionProceso.vue?vue&type=template&id=2956c9ef&scoped=true"
import script from "./SeccionProceso.vue?vue&type=script&lang=js"
export * from "./SeccionProceso.vue?vue&type=script&lang=js"
import style0 from "./SeccionProceso.vue?vue&type=style&index=0&id=2956c9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956c9ef",
  null
  
)

export default component.exports